import { Routes, Route, Navigate } from 'react-router-dom'
import MethodPicker from './routes/MethodPicker'
import SepaForm from './routes/SepaForm'
import UsdcForm from './routes/UsdcForm'
import LightningForm from './routes/LightningForm'
import Confirm from './routes/Confirm'
import Receipt from './routes/Receipt'
import NotFound from './routes/NotFound'

export default function App() {
  return (
    <Routes>
      <Route path="/p/:surveyId" element={<MethodPicker />} />
      <Route path="/p/:surveyId/sepa" element={<SepaForm />} />
      <Route path="/p/:surveyId/usdc" element={<UsdcForm />} />
      <Route path="/p/:surveyId/lightning" element={<LightningForm />} />
      <Route path="/p/:surveyId/confirm" element={<Confirm />} />
      <Route path="/r/:receiptId" element={<Receipt />} />
      <Route path="/" element={<Navigate to="/p/missing" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
